import toast from "../component/toast.vue";
import Vue from "vue";

const CONTAINER_ID = 'toast_container'

export default {
    show({content = '', stayTime = 2000, withMask = true}) {
        this.hide();

        const container = document.querySelector(`#${CONTAINER_ID}`) || document.createElement('div');
        container.id = CONTAINER_ID;
        document.documentElement.append(container);

        const hideToast = () => {
            this.hide();
        };

        return new Promise((resolve => {
            window.toast_instance = new Vue({
                render: h => h(toast, {
                    props: {
                        content,
                        stayTime,
                        withMask
                    },
                    on: {
                        close() {
                            hideToast();
                            resolve();
                        }
                    }
                })
            }).$mount(container);
        }))
    },
    hide() {
        const target = window.toast_instance;
        if (target) {
            const wrapper = target.$el
            target.$destroy();
            if (wrapper) {
                wrapper.remove();
            }
        }
        window.toast_instance = null;
    }
}